//時間を変換する関数 (日付なしver.)

import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

interface TimeConverterOptions {
  timezone?: string;
  formatString?: string;
}

export const TimeConverter = (
  time: string,
  TimeConverterOptions: TimeConverterOptions = {}
) => {
  //デフォルト値設定
  const { timezone = "Asia/Tokyo", formatString = "HH:mm:ss" } =
    TimeConverterOptions;

  //今日の日付を仮で取得
  const today = new Date();
  const dateString = format(today, "yyyy-MM-dd");

  //日付と時間をフォーマットに UTCの場合は末尾にZ
  const dateTimeString =
    timezone !== "UTC" ? `${dateString}T${time}Z` : `${dateString}T${time}`;
  const date = parseISO(dateTimeString);
  const ConvertedDate = toZonedTime(date, timezone);

  //時間部分のみを抽出
  const formattedDateTime = format(ConvertedDate, formatString);

  return formattedDateTime;
};
